module.exports = "../images/boat-rentals.svg?v=96e1994";